<div class="flex flex-column">
    <label for="timezone">Time Zone</label>
    <p-select
        inputId="timezone"
        class="flex flex-1 w-full"
        [options]="(timeZones$ | async) ?? []"
        optionLabel="timeZone"
        [filter]="true"
        [(ngModel)]="selectedTimeZone"
        (onChange)="onTimeZoneChange()"
        placeholder="Select a Time Zone">
        <ng-template pTemplate="filtericon"><i class="pi pi-filter"></i></ng-template>
        <ng-template let-item pTemplate="selectedItem">
            @if (item) {
                {{ item.timeZone }} (UTC{{ item.offset }})
            }
        </ng-template>
        <ng-template let-item pTemplate="item">
            {{ item.timeZone }} (UTC{{ item.offset }})
        </ng-template>
    </p-select>
</div>